const types = [
  {
    title: 'Критика личности',
    desc: '«Ты всегда всё делаешь неправильно» — оценка человека, а не его действий. Вызывает защитную реакцию и сопротивление.',
    isNegative: true,
  },
  {
    title: 'Оценка поведения',
    desc: '«На вчерашней встрече ты трижды перебил коллегу» — конкретный наблюдаемый факт, а не характеристика сотрудника.',
    isNegative: false,
  },
  {
    title: 'Обсуждение результата',
    desc: '«Отчёт сдан на два дня позже срока, из-за этого задержалось согласование бюджета» — связь действия и последствия.',
    isNegative: false,
  },
  {
    title: 'Развивающая обратная связь',
    desc: 'Обсуждение сильных сторон и зон роста сотрудника с фокусом на будущее. Помогает сотруднику понять, куда двигаться дальше.',
    isNegative: false,
  },
  {
    title: 'Корректирующая обратная связь',
    desc: 'Указание на конкретное отклонение от ожидаемого поведения или результата с договорённостью о том, что должно измениться.',
    isNegative: false,
  },
  {
    title: 'Положительная обратная связь',
    desc: 'Подтверждение правильных действий сотрудника. Важна не меньше корректирующей: закрепляет эффективное поведение.',
    isNegative: false,
  },
];

export default function WhatIsEffectiveFeedback() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4">
          Обратная связь — это инструмент управления, а не критика
        </h2>
        <p className="text-base md:text-lg text-gray-600 mb-4 max-w-3xl leading-relaxed">
          Задача руководителя — не «высказать сотруднику всё, что он думает», а помочь изменить конкретное поведение и договориться о дальнейшем результате
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
          {types.map((t) => (
            <div key={t.title} className={`rounded-xl border p-5 ${t.isNegative ? 'bg-red-50 border-red-200' : 'bg-white border-gray-200 hover:border-teal-300'} transition-colors`}>
              <h3 className={`font-bold text-sm mb-2 ${t.isNegative ? 'text-red-700' : 'text-gray-900'}`}>{t.title}</h3>
              <p className={`text-xs leading-relaxed ${t.isNegative ? 'text-red-700/80' : 'text-gray-600'}`}>{t.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-3xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Обратная связь работает, когда она конкретна, своевременна, направлена на поведение и завершается договорённостью о будущем результате.
          </p>
        </div>
      </div>
    </section>
  );
}